var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vscode-container"},[_c('div',{staticClass:"left-panel"},[_c('Inbox',{on:{"chatItemClick":_vm.handleChatItemClick}})],1),_c('div',{staticClass:"right-panel"},[_c('shadan-chat',{attrs:{"chatData":_vm.selectedChatData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }